<template>
    	<div class="profile-sidebar notmobile_menu">
            <div class="widget-profile pro-widget-content">
                <div class="profile-info-widget">
                    <a href="#" class="booking-doc-img">
                        <img src="@/assets/img/user2.jpg" alt="User Image">
                    </a>
                    <div class="profile-det-info">
                        <h3>{{user.namauser}}</h3>
                        <div class="receiver-details">
                            <h5>{{(user.hak_akses == '3')?"Admin":"-"}}</h5>
                            <!-- <h5 class="mb-0"><i class="fas fa-map-marker-alt"></i> Newyork, USA</h5> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="dashboard-widget">
                <nav class="dashboard-menu">
                    <ul>
                        
                    <template v-if="user.hak_akses == '3'">
                        <li v-bind:class="{'active': currentPath == 'admin-profile-settings'}">
                            <router-link to="/admin/profile-settings">
                                <i class="fas fa-user-cog"></i>
                                <span>Identitas Diri</span>
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'admin-ref-home'}">
                            <router-link to="/admin/ref-home">
                                <i class="fas fa-list"></i>
                                <span>Manajemen Home</span>
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'admin-ref-tingkatan'}">
                            <router-link to="/admin/ref-tingkatan">
                                <i class="fas fa-list"></i>
                                <span>Manajemen Referensi</span>
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'admin-materi'}">
                            <router-link to="/admin/materi">
                                <i class="fas fa-list"></i>
                                <span>Manajemen Materi</span>
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'admin-tryout'}">
                            <router-link to="/admin/tryout">
                                <i class="fas fa-list"></i>
                                <span>Manajemen Try Out</span>
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'admin-kelas-saya'}">
                            <router-link to="/admin/kelas-saya">
                                <i class="fas fa-calendar-check"></i>
                                <span>Manajemen Paket</span>
                                <small class="unread-msg">{{cntPaket}}</small>
                            </router-link>
                        </li> 
                        <li v-bind:class="{'active': currentPath == 'admin-bimbel'}">
                            <router-link to="/admin/bimbel">
                                <i class="fas fa-calendar-check"></i>
                                <span>Manajemen Bimbel</span>
                            </router-link>
                        </li> 
                        <li v-bind:class="{'active': currentPath == 'admin-user'}">
                            <router-link to="/admin/user">
                                <i class="fas fa-users"></i>
                                <span>Manajemen User</span>
                                <small class="unread-msg">{{cntUser}}</small>
                            </router-link>
                        </li>                       
                        <li v-bind:class="{'active': currentPath == 'admin-wallet'}">
                            <router-link to="/admin/wallet">
                                <i class="fas fa-wallet"></i>
                                <span>Manajemen Referral</span>
                                <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                               
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'admin-penjualan'}">
                            <router-link to="/admin/penjualan">
                                <i class="fas fa-columns"></i>
                                <span>Penjualan</span>
                                <small class="unread-msg">{{cntPenjualan}}</small>
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'admin-keuangan'}">
                            <router-link to="/admin/keuangan">
                                <i class="fas fa-wallet"></i>
                                <span>Manajemen Keuangan</span>
                            </router-link>
                        </li>                        
                        <li v-bind:class="{'active': currentPath == 'admin-laporsoal'}">
                            <router-link to="/admin/laporsoal">
                                <i class="fas fa-wallet"></i>
                                <span>Laporan Soal</span>
                                <!-- <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                                -->
                            </router-link>
                        </li>                         
                        <li v-bind:class="{'active': currentPath == 'admin-rank'}">
                            <router-link to="/admin/rank">
                                <i class="fas fa-trophy"></i>
                                <span>Peringkat Hasil Tryout</span>
                                <!-- <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                                -->
                            </router-link>
                        </li>                           
                        <li v-bind:class="{'active': currentPath == 'admin-rank-paket'}">
                            <router-link to="/admin/rank-paket">
                                <i class="fas fa-trophy"></i>
                                <span>Peringkat Hasil Paket</span>
                                <!-- <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                                -->
                            </router-link>
                        </li>                          
                        <li v-bind:class="{'active': currentPath == 'admin-giveaway'}">
                            <router-link to="/admin/giveaway">
                                <i class="fas fa-gift"></i>
                                <span>Giveaway Paket</span>
                                <!-- <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                                -->
                            </router-link>
                        </li>                
                        <!-- <li v-bind:class="{'active': currentPath == 'admin-laporsoal'}">
                            <router-link to="/admin/laporsoal">
                                <i class="fas fa-wallet"></i>
                                <span>Laporan Soal</span>
                                <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                               
                            </router-link>
                        </li> -->
                        <li>
                            <a @click="logout">
                                <i class="fas fa-sign-out-alt"></i>
                                <span>Keluar</span>
                            </a>
                        </li>
                    </template>
                    
                    </ul>
                </nav>
            </div>
            <div class="widget-profile pro-widget-content">
                <div class="profile-info-widget">
                    <a href="https://wa.me/+6285183033543" target="_blank" class="booking-doc-img  bg-white">
                        <img src="@/assets/img/cs2.jpg" alt="User Image">
                    </a>
                    <div class="profile-det-info">
                        <p>Anda mengalami kesulitan? <br>silahkan klik tombol berikut</p>
                        <div class="receiver-details">
                            <a href="https://wa.me/+6285183033543" target="_blank" class="btn btn-sm bg-warning">
                                 Hubungi Kami
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import Util from '../../../assets/utils/utils'
import {mapGetters} from 'vuex'
import store from '../../../store'
import axios from 'axios';

export default {
    
    data() {
        return {
            cntPaket: 0, cntUser: 0, cntPenjualan: 0
        }
    },
    created: function () {
        if(localStorage.getItem('token')){
            store.dispatch("checktoken");
        }
        this.getCntPaket();
        this.getCntUser();
        this.getCntPenjualan();
    },
    methods: {
        logout: function() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
            });
        },
        getCntPaket: function () {
            axios.get('api/cntpaket')
                .then(res => {
                    this.cntPaket = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        getCntUser: function () {
            axios.get('api/cntuser')
                .then(res => {
                    this.cntUser = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        getCntPenjualan: function () {
            axios.get('api/cntpenjualan')
                .then(res => {
                    this.cntPenjualan = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
        currentPath() {
            return this.$route.name
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/Sidebar/index.vue